'use client';

import { ContentAssistant } from '@/components/content/ContentAssistant';

export default function ContentAssistantPage() {
  return (
    <div className="h-full p-4">
      <div className="h-full max-w-4xl mx-auto">
        <ContentAssistant />
      </div>
    </div>
  );
}
